// @flow
import type { UnauthSeoExperiments } from 'app/common/lib/react/withUnauthSeoExperiments';
import UnauthUsage from 'app/common/lib/UnauthUsage';
import {
  BANNER_TYPE,
  MODAL_BEHAVIOR,
  MODAL_TYPE,
} from 'app/common/react/components/growth/unauth/open/closeup/CloseupContent/HybridCloseupBanner';
import {
  HybridTiers,
  LOGIN_SIGNUP_MODAL_COOLDOWN_SECONDS,
  TIER1_CLOSEUP_MODAL_PERIOD,
  TIER2_CLOSEUP_MODAL_LIMIT,
  TIER3_CLOSEUP_MODAL_LIMIT,
} from 'app/common/react/components/growth/unauth/open/hybrid/hybridConstants';

type BannerInfo = {
  bannerType?: string,
  hideLoginSignupButtons?: boolean,
  modalType?: string,
  modalBehavior?: string,
  viewsLeft?: number,
};

function tier1BannerInfo(numCloseupsSeen: number, period: number) {
  const defaultBannerInfo = {
    bannerType: BANNER_TYPE.BANNER_WITHOUT_COUNTER,
    modalType: MODAL_TYPE.LOGIN,
  };
  if (numCloseupsSeen === 1 || numCloseupsSeen % period === 0) {
    return {
      ...defaultBannerInfo,
      modalBehavior: MODAL_BEHAVIOR.DISMISSIBLE,
    };
  }
  return defaultBannerInfo;
}

function tier2BannerInfo(numCloseupsSeen: number, limit: number) {
  if (numCloseupsSeen <= limit) {
    return {
      bannerType: BANNER_TYPE.BANNER_WITH_COUNTER,
      modalBehavior: MODAL_BEHAVIOR.DISMISSIBLE,
      modalType: MODAL_TYPE.SIGNUP_OR_PERSONAL_LOGIN,
      viewsLeft: limit - numCloseupsSeen,
    };
  } else {
    return {
      bannerType: BANNER_TYPE.BANNER_WITHOUT_COUNTER,
      modalBehavior: MODAL_BEHAVIOR.BLOCKING,
      modalType: MODAL_TYPE.SIGNUP_OR_PERSONAL_LOGIN,
      hideLoginSignupButtons: true,
    };
  }
}

function tier3BannerInfo(numCloseupsSeen: number, limit: number) {
  if (numCloseupsSeen <= limit) {
    return {
      bannerType: BANNER_TYPE.BANNER_WITH_COUNTER,
      modalBehavior: MODAL_BEHAVIOR.DISMISSIBLE,
      modalType: MODAL_TYPE.SIGNUP_OR_PERSONAL_LOGIN,
      viewsLeft: limit - numCloseupsSeen,
    };
  } else {
    return {
      bannerType: BANNER_TYPE.BANNER_WITHOUT_COUNTER,
      modalBehavior: MODAL_BEHAVIOR.BLOCKING,
      modalType: MODAL_TYPE.SIGNUP_OR_PERSONAL_LOGIN,
      hideLoginSignupButtons: true,
    };
  }
}

export function isInLoginSignupModalCooldown() {
  const lastLoginSignupModalView = UnauthUsage.getLoginSignupModalView();
  return (
    Math.ceil((Date.now() - lastLoginSignupModalView) / 1000) < LOGIN_SIGNUP_MODAL_COOLDOWN_SECONDS
  );
}

/*
* Given a market tier (either tier1, tier2, or tier3), this will return the banner type
*/
export default function getBannerInfo(
  marketTier: string,
  numCloseupsSeen: number,
  expClient: UnauthSeoExperiments,
): BannerInfo {
  switch (marketTier) {
    case HybridTiers.tier1:
      return tier1BannerInfo(numCloseupsSeen, TIER1_CLOSEUP_MODAL_PERIOD);
    case HybridTiers.tier2:
      return tier2BannerInfo(numCloseupsSeen, TIER2_CLOSEUP_MODAL_LIMIT);
    case HybridTiers.tier3:
      return tier3BannerInfo(numCloseupsSeen, TIER3_CLOSEUP_MODAL_LIMIT);
    default:
      return {};
  }
}
